const ReviewRefreshBtnV2 = (props) => {
    return (
        <div className={"review-refresh-v2"} onClick={props?.refresh}>
                <button className={`review-refresh-v2-btn`}>
                    {("refresh")}
                </button>
        </div>
    );
};

export default ReviewRefreshBtnV2;
